import { Component } from '@angular/core';

@Component({
  selector: 'app-section-instructions',
  templateUrl: './section-instructions.component.html',
  styleUrls: ['./section-instructions.component.scss']
})
export class SectionInstructionsComponent {
    imagesPart3 = [
        { filename: '1.png' },
        { filename: '2.png' },
        { filename: '3.png' },
        { filename: '4.png' },
        // Añade más imágenes según sea necesario
    ];

}
